<div class="auth-page">
  <a href="#" class="auth-page__home-link" aria-label="Go to home page">
    <i class="fas fa-home"></i>
  </a>

  <div class="auth-card">
    <div class="auth-card__inner">
      <img src="/assets/images/logoNav.png" class="auth-card__logo" alt="LIC logo" />
      <h4 class="auth-card__heading">Welcome to LIC</h4>
      <p class="auth-card__subheading">ยินดีต้อนรับสู่ LIC</p>
      <div class="auth-card__divider"></div>

      <form #login="ngForm" (ngSubmit)="onSubmit(login)" class="auth-form" novalidate>
        <div class="auth-form__group">
          <label class="auth-form__label" for="signInEmail">
            Email
            <span class="auth-form__label-thai">อีเมล</span>
          </label>
          <input id="signInEmail" required email type="email" class="auth-form__input" name="email"
            placeholder="email@address.com" #email="ngModel" ngModel autocomplete="email" />
        </div>

        <div class="auth-form__group">
          <label class="auth-form__label" for="signInPassword">
            Password
            <span class="auth-form__label-thai">รหัสผ่าน</span>
          </label>
          <div class="auth-form__password-wrapper">
            <input id="signInPassword" required minlength="5" [type]="isHidePass ? 'password' : 'text'"
              class="auth-form__input" name="password" placeholder="minimum 5 characters" #password="ngModel" ngModel
              autocomplete="current-password" />
            <button type="button" class="auth-form__toggle-pass" (click)="isShow()"
              [attr.aria-label]="isHidePass ? 'Show password' : 'Hide password'">
              <i class="fa" [ngClass]="isHidePass ? 'fa-eye' : 'fa-eye-slash'"></i>
            </button>
          </div>
        </div>

        <a href="/forgot" class="auth-form__forgot-link">
          Forgot password?
          <span class="auth-form__label-thai">ลืมรหัสผ่าน</span>
        </a>

        <button type="submit" [disabled]="!login.valid" class="auth-form__submit">
          Sign in
          <span class="auth-form__label-thai">เข้าสู่ระบบ</span>
        </button>
      </form>

      <div class="auth-card__footer">
        <p>ยังไม่เป็นสมาชิก? <a href="/signUp">ลงทะเบียน</a></p>
        <p>Don't have an account? <a href="/signUp">Register here</a></p>
      </div>
    </div>
  </div>

  <div class="auth-circles" aria-hidden="true">
    <div class="auth-circle auth-circle--1"></div>
    <div class="auth-circle auth-circle--2"></div>
    <div class="auth-circle auth-circle--3"></div>
    <div class="auth-circle auth-circle--4"></div>
  </div>
</div>

<notifier-container></notifier-container>
